/**
 * One phone formatter, used everywhere a phone number is typed: capture,
 * contact edit, and rep profile edit. Previously each place had its own
 * (or none at all): MeetingForm.jsx formatted on blur, EditContact.jsx
 * had no formatting until today, RepProfileFields.jsx still had none. Same
 * bug fixed three different ways, or not fixed, is how a stored phone number
 * ends up in three different shapes depending on which screen wrote it.
 *
 * Formats progressively as digits are typed, not only once focus leaves the
 * field, and always displays the bare 10 digit US number: a leading "1"
 * (from a pasted +1 415 555 0100, or an 11 digit number) is dropped rather
 * than shown as a fourth area-code-looking group.
 *
 * What actually gets stored is whatever this function returns, since the
 * form's own state is set to it on every keystroke. That is fine for
 * Twilio: toE164 (worker/lib/messages.ts) strips every non-digit character
 * before building the E.164 number it sends, so it is unaffected by
 * whether the stored string is formatted, unformatted, or a leftover raw
 * digit string from before this existed.
 */
export function formatPhoneAsTyped(raw) {
  if (!raw) return raw ?? '';

  const digits = raw.replace(/\D/g, '');
  const local = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits.slice(0, 10);

  if (local.length === 0) return '';
  if (local.length < 4) return local;
  if (local.length < 7) return `(${local.slice(0, 3)}) ${local.slice(3)}`;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}
